import React, { useEffect, useState } from "react";
import { Form, Card, CardBody, CardHeader } from "reactstrap";
import { useFormik } from "formik";
import ClipLoader from "react-spinners/ClipLoader";

import Animation from "@areas/shared/components/chooseLayout/Animation";
import animationStyles from "@areas/shared/components/chooseLayout/styles/animations.module.css";

import {
  FormBody,
  initialValues,
  validationSchema,
  confirm,
} from "./blocks/Form";
import LoadBlock from "@areas/shared/components/personal/loads/LoadBlock";

import { fetchWrapper } from "@helpers/fetchwrapper";

import styles from "@areas/shared/components/personal/modals/styles/customModal.module.css";

function Frame(props) {
  const [load, setLoad] = useState(false);
  const [data, setData] = useState([]);

  const loadData = () => {
    setLoad(true);
    fetchWrapper.get(`/v1/api/app/typePage?type=11`).then((res) => {
      setData(res);
      setLoad(false);
    });
  };

  useEffect(() => {
    loadData();
  }, []);

  const inititalValues = () => {
    return initialValues(data);
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: inititalValues(),
    validationSchema: validationSchema(),
    onSubmit: (values) => {
      confirm(values, setLoad);
    },
  });

  return (
    <div>
      <Animation
        animationIn={animationStyles.fadeIn}
        animationOut={animationStyles.fadeOut}
      >
        <Card>
          <CardHeader>
            <div className="d-flex justify-content-between align-items-center">
              <h5 className="mb-0">О нас</h5>
            </div>
          </CardHeader>
          <CardBody>
            <Form
              className="tablelist-form"
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            >
              <FormBody validation={validation} />
              <div className={`mt-3 ${styles.footer}`}>
                <div className="hstack gap-2 justify-content-end">
                  <button
                    type="submit"
                    className={`btn btn-success ${styles.submit}`}
                    id="add-btn"
                  >
                    Сохранить
                  </button>
                </div>
              </div>
            </Form>
            <LoadBlock visible={load}>
              <ClipLoader />
            </LoadBlock>
          </CardBody>
        </Card>
      </Animation>
    </div>
  );
}

export default Frame;
